/**
 * Clear markers from layer
 *
 * @param {*} layer
 * @param {*} markers
 */

export function clearMarkers(layer, markers) {
    markers && markers.removeLayer(layer);
    layer.clearLayers();
}
